<template>
  <div
    class="w-auto h-auto collapse navbar-collapse h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- Dashboard -->
      <li class="nav-item">
        <sidenav-collapse
          to="/dashboard"
          activeRoute="dashboard"
          navText="Dashboard"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Orders -->
      <li class="nav-item">
        <sidenav-collapse to="/orders" activeRoute="orders" navText="Orders">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">receipt_long</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Reviews -->
      <li class="nav-item">
        <sidenav-collapse to="/reviews" activeRoute="reviews" navText="Reviews">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">rate_review</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Categories -->
      <li class="nav-item">
        <sidenav-collapse
          to="/categories"
          activeRoute="categories"
          navText="Categories"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">layers</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Products -->
      <li class="nav-item">
        <sidenav-collapse
          to="/products"
          activeRoute="products"
          navText="Products"
        >
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">inventory_2</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Cities -->
      <li class="nav-item">
        <sidenav-collapse to="/cities" activeRoute="cities" navText="Cities">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">travel_explore</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  components: {
    SidenavCollapse,
  },
};
</script>
